import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Row, Col } from 'antd';
import { MODULES_FIELDS, DEFAULT_SERVER_STATUS } from '../constants';

export default function SettingModal({ visible, onCancel, onSave, initialData }) {
  const [form] = Form.useForm();
  const [serverResponse, setServerResponse] = useState(DEFAULT_SERVER_STATUS);

  useEffect(() => {
    if (visible) {
      setServerResponse(DEFAULT_SERVER_STATUS);
      if (initialData) {
        form.setFieldsValue(initialData);
      } else {
        form.resetFields();
      }
    }
  }, [initialData, form, visible]);

  const onFinish = async values => {
    const response = await onSave({ ...initialData, ...values });
    const { success, code, message } = response;
    setServerResponse({success, code, message});
    if (success && !message) {
      form.resetFields();
    }
  };

  const onEdit = () => {
    setServerResponse(DEFAULT_SERVER_STATUS);
  }

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title='Add Settings'
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        name="customer"
        layout="vertical"
        onFinish={onFinish}
        >
        <Row gutter={16}>
            {MODULES_FIELDS.map(field => (
              <Col
                key={field.name}
                xs={24}
                sm={24}
                md={12}
              >
                <Form.Item
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  rules={field.rules}
                >
                  <Input onChange={() => {onEdit()}} />
                </Form.Item>
            </Col>
            ))}
        </Row>
        </Form>
        {
          (!serverResponse.status && serverResponse.message) &&
          <div style={{textAlign: 'center'}}>
            <label style={{color: 'red'}}>{serverResponse.message} {serverResponse.code ? `(${serverResponse.code})` : ''}</label>
          </div>
        }
    </Modal>
  );
}
